import { useRef } from 'react';

/**
 * Stable ref wrapper. Prevents stale-closure bugs inside long-lived callbacks
 * (drag event handlers, rAF loops) without triggering re-renders.
 */
export function useLatest<T>(value: T): { readonly current: T } {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
